<div class="container-fluid padding-top padding-bottom">
  <md-card *ngIf="smallPrimaryIconBar; else loading">
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary"
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>{{ clientData?.name}}</h1>
        <h3>{{ locationData?.name}}</h3>
      </div>
      <div class="col-md-12">
        <h2>Component Data Settings</h2>
      </div>
    </div>
    <div class="row"
         *ngIf="pageSettings?.locationHome.headerType == 'insights'">
      <div class="col-md-12">
        <h5>Location Insights Hero</h5>
      </div>
      <div class="col-md-8">
        <label for="hero-title">Title</label>
        <input class="full-width"
               pInputText
               id="hero-title"
               (change)="updateLocation()"
               [(ngModel)]="locationData.insightsHero.title">
        <label for="hero-subtitle">Subtitle</label>
        <input class="full-width"
               pInputText
               id="hero-subtitle"
               (change)="updateLocation()"
               [(ngModel)]="locationData.insightsHero.subtitle">
      </div>

    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-8">
        <h5>Location Specific Buttons</h5>
        <div class="row">
          <div class="col-sm-6">
            <label for="left-button-text">Left Button Text</label>
            <input class="full-width"
                   pInputText
                   id="left-button-text"
                   (change)="updateLocation()"
                   [(ngModel)]="locationData.heroLeftButtonText">
          </div>
          <div class="col-sm-6">
            <label for="left-button-link">Left Button Link</label>
            <input class="full-width"
                   pInputText
                   id="left-button-link"
                   (change)="updateLocation()"
                   [(ngModel)]="locationData.heroLeftButtonLink">
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <label for="right-button-text">Right Button Text</label>
            <input class="full-width"
                   pInputText
                   id="right-button-text"
                   (change)="updateLocation()"
                   [(ngModel)]="locationData.heroRightButtonText">
          </div>
          <div class="col-sm-6">
            <label for="right-button-link">Right Button Link</label>
            <input class="full-width"
                   pInputText
                   id="right-button-link"
                   (change)="updateLocation()"
                   [(ngModel)]="locationData.heroRightButtonLink">
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h5>Small Primary Icon Bar</h5>
      </div>
      <div class="col-md-8">
        <label for="title">Main Title</label>
        <input *ngIf="this.clientData.homePageMainIconsComponent == 'v3'"
               class="full-width"
               pInputText
               id="title"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.title" />
      </div>
      <div class="col-md-8">
        <label for="title1">Title 1</label>
        <input class="full-width"
               pInputText
               id="title1"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.title1" />
        <label for="icon1url">Title 1 Icon URL</label>
        <input *ngIf="this.clientData.homePageMainIconsComponent !== 'svg' && this.clientData.homePageMainIconsComponent !== 'v3'; else svgIconSelectLg1"
               class="full-width"
               pInputText
               #icon1url
               (change)="saveBar()"
               id="icon1url"
               [(ngModel)]="smallPrimaryIconBar.icon1url" />
        <ng-template #svgIconSelectLg1>
          <p-dropdown [filter]="true"
                      (onChange)="saveBar()"
                      [(ngModel)]="smallPrimaryIconBar.icon1url"
                      [options]="iconOptions"></p-dropdown>
        </ng-template>
        <label for="card3url">Title 1 Card URL</label>
        <input *ngIf="this.clientData.homePageMainIconsComponent == 'v3';"
               class="full-width"
               pInputText
               #card1url
               (change)="saveBar()"
               id="card1url"
               [(ngModel)]="smallPrimaryIconBar.card1url" />
        <label for="text1">Text</label>
        <input class="full-width"
               pInputText
               id="text1"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.text1" />
        <label for="backText1"
               *ngIf="this.clientData.homePageMainIconsComponent !== 'v3'">Back Text</label>
        <input class="full-width"
               *ngIf="this.clientData.homePageMainIconsComponent !== 'v3'"
               pInputText
               id="backText1"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.backText1" />
        <label for="seoTitle1">SEO Title</label>
        <input class="full-width"
               pInputText
               id="seoTitle1"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.seoTitle1" />
        <label for="alt1">Alt 1</label>
        <input class="full-width"
               pInputText
               id="alt1"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.alt1" />
      </div>
      <div class="col-md-4">
        <img *ngIf="this.clientData.homePageMainIconsComponent !== 'svg' && this.clientData.homePageMainIconsComponent !== 'v3'; else showSvg1"
             [src]="smallPrimaryIconBar.icon1url"
             class="icon-image"
             alt="">
        <ng-template #showSvg1>
          <div [innerHtml]="smallPrimaryIconBar.icon1url | keepHtml"></div>
        </ng-template>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-8">
        <label for="title2">Title 2</label>
        <input class="full-width"
               pInputText
               id="title2"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.title2" />
        <label for="icon2url">Title 2 Icon URL</label>
        <input *ngIf="this.clientData.homePageMainIconsComponent !== 'svg' && this.clientData.homePageMainIconsComponent !== 'v3'; else svgIconSelectLg2"
               class="full-width"
               pInputText
               #icon2url
               (change)="saveBar()"
               id="icon2url"
               [(ngModel)]="smallPrimaryIconBar.icon2url" />
        <ng-template #svgIconSelectLg2>
          <p-dropdown [filter]="true"
                      (onChange)="saveBar()"
                      [(ngModel)]="smallPrimaryIconBar.icon2url"
                      [options]="iconOptions"></p-dropdown>
        </ng-template>
        <label for="card3url">Title 2 Card URL</label>
        <input *ngIf="this.clientData.homePageMainIconsComponent == 'v3';"
               class="full-width"
               pInputText
               #card2url
               (change)="saveBar()"
               id="card2url"
               [(ngModel)]="smallPrimaryIconBar.card2url" />
        <label for="text2">Text</label>
        <input class="full-width"
               pInputText
               id="text2"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.text2" />
        <label for="backText2"
               *ngIf="this.clientData.homePageMainIconsComponent !== 'v3'">Back Text</label>
        <input class="full-width"
               *ngIf="this.clientData.homePageMainIconsComponent !== 'v3'"
               pInputText
               id="backText2"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.backText2" />
        <label for="seoTitle2">SEO Title</label>
        <input class="full-width"
               pInputText
               id="seoTitle2"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.seoTitle2" />
        <label for="alt2">Alt 2</label>
        <input class="full-width"
               pInputText
               id="alt2"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.alt2" />
      </div>
      <div class="col-md-4">
        <img *ngIf="this.clientData.homePageMainIconsComponent !== 'svg' && this.clientData.homePageMainIconsComponent !== 'v3'; else showSvg2"
             [src]="smallPrimaryIconBar.icon2url"
             class="icon-image"
             alt="">
        <ng-template #showSvg2>
          <div [innerHtml]="smallPrimaryIconBar.icon2url | keepHtml"></div>
        </ng-template>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-8">
        <label for="title3">Title 3</label>
        <input class="full-width"
               pInputText
               id="title3"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.title3" />
        <label for="icon3url">Title 3 Icon URL</label>
        <input *ngIf="this.clientData.homePageMainIconsComponent !== 'svg' && this.clientData.homePageMainIconsComponent !== 'v3'; else svgIconSelectLg3"
               class="full-width"
               pInputText
               #icon3url
               (change)="saveBar()"
               id="icon3url"
               [(ngModel)]="smallPrimaryIconBar.icon3url" />
        <ng-template #svgIconSelectLg3>
          <p-dropdown [filter]="true"
                      (onChange)="saveBar()"
                      [(ngModel)]="smallPrimaryIconBar.icon3url"
                      [options]="iconOptions"></p-dropdown>
        </ng-template>
        <label for="card3url">Title 3 Card URL</label>
        <input *ngIf="this.clientData.homePageMainIconsComponent == 'v3';"
               class="full-width"
               pInputText
               #card3url
               (change)="saveBar()"
               id="card3url"
               [(ngModel)]="smallPrimaryIconBar.card3url" />
        <label for="text3">Text</label>
        <input class="full-width"
               pInputText
               id="text3"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.text3" />
        <label for="backText3"
               *ngIf="this.clientData.homePageMainIconsComponent !== 'v3'">Back Text</label>
        <input class="full-width"
               *ngIf="this.clientData.homePageMainIconsComponent !== 'v3'"
               pInputText
               id="backText3"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.backText3" />
        <label for="seoTitle3">SEO Title</label>
        <input class="full-width"
               pInputText
               id="seoTitle3"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.seoTitle3" />
        <label for="alt3">Alt 3</label>
        <input class="full-width"
               pInputText
               id="alt3"
               (change)="saveBar()"
               [(ngModel)]="smallPrimaryIconBar.alt3" />
      </div>
      <div class="col-md-4">
        <img *ngIf="this.clientData.homePageMainIconsComponent !== 'svg' && this.clientData.homePageMainIconsComponent !== 'v3'; else showSvg3"
             [src]="smallPrimaryIconBar.icon3url"
             class="icon-image"
             alt="">
        <ng-template #showSvg3>
          <div [innerHtml]="smallPrimaryIconBar.icon3url | keepHtml"></div>
        </ng-template>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5>Features Component</h5>
        <button class="btn btn-secondary"
                (click)="setFeaturesToParent()">Set Features To Clients</button>
        <button class="btn btn-secondary"
                (click)="setSmallPrimaryIconBarToParent()">Set Small Primary Icon Bar To Clients</button>
      </div>
      <div class="col-md-6 margin-top">
        <p-dataTable [value]="features"
                     [(selection)]="selectedFeature"
                     (onEditComplete)="saveFeature($event)"
                     [responsive]="true"
                     [editable]="true"
                     class="text-center">
          <p-header>Features Component</p-header>
          <p-column field="iconUrl"
                    header="Icon URL"
                    [editable]="true">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <span *ngIf="this.clientData.homePageFeaturesComponent !== 'svg'; else svgIcon"><img class="facility-logo"
                     [src]="car[col.field]"
                     alt=""></span>
              <ng-template #svgIcon>
                <div [innerHtml]="car[col.field] | keepHtml"></div>
              </ng-template>
            </ng-template>
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="editor">
              <input *ngIf="this.clientData.homePageFeaturesComponent !== 'svg'; else svgIconSelect"
                     pInputText
                     id="iconUrl"
                     (change)="saveFeature({data: car})"
                     [(ngModel)]="car[col.field]" />
              <ng-template #svgIconSelect>
                <p-dropdown [filter]="true"
                            [(ngModel)]="car[col.field]"
                            (onChange)="saveFeature({data: car})"
                            [options]="iconOptions"></p-dropdown>
              </ng-template>
            </ng-template>
          </p-column>
          <p-column field="name"
                    header="Name"
                    [editable]="true"></p-column>
          <p-column field="alt"
                    header="Title/Alt"
                    [editable]="true"></p-column>
          <p-column field="description"
                    header="Description"
                    [editable]="true"></p-column>
          <p-column field="delete"
                    header="Delete">
            <ng-template let-col
                         let-car="rowData"
                         pTemplate="body">
              <button type="button"
                      class="btn btn-primary"
                      color="primary"
                      icon="fa-close"
                      (click)="deleteFeature(car)"
                      label="Delete"><i class="fa fa-close"
                   aria-hidden="true"></i> Delete</button>
            </ng-template>
          </p-column>
          <p-footer>
            <div class="ui-helper-clearfix"
                 style="width:100%">
              <button type="button"
                      class="btn btn-primary"
                      color="primary"
                      style="float:left"
                      (click)="showFeatureDialogToAdd()">
                <i class="fa fa-plus"
                   aria-hidden="true"></i> Add
              </button>
            </div>
          </p-footer>
        </p-dataTable>


      </div>
    </div>
    <p-dialog header="Features Component Details"
              [(visible)]="displayFeatureDialog"
              [responsive]="true"
              showEffect="fade"
              [modal]="true"
              [positionTop]="100"
              [dismissableMask]="true">
      <div class="ui-grid ui-grid-responsive ui-fluid"
           *ngIf="feature">
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="name">Name</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   id="name"
                   [(ngModel)]="feature.name" />
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="iconUrl">Icon URL</label>
          </div>
          <div class="ui-grid-col-8">
            <input *ngIf="this.clientData.homePageFeaturesComponent !== 'svg'; else svgIconSelect2"
                   pInputText
                   id="iconUrl"
                   [(ngModel)]="feature.iconUrl" />
            <ng-template #svgIconSelect2>
              <p-dropdown [filter]="true"
                          [(ngModel)]="feature.iconUrl"
                          [options]="iconOptions"></p-dropdown>
            </ng-template>
          </div>
        </div>
        <div class="ui-grid-row sm-padding-top">
          <div class="ui-grid-col-4">
            <label for="alt">Title/Alt</label>
          </div>
          <div class="ui-grid-col-8">
            <input pInputText
                   id="alt"
                   [(ngModel)]="feature.alt" />
          </div>
        </div>
      </div>
      <p-footer>
        <div class="ui-dialog-buttonpane ui-helper-clearfix">
          <button class="btn btn-primary"
                  color="primary"
                  (click)="saveFeature()"><i class="fa fa-check"
               aria-hidden="true"></i> Save</button>
        </div>
      </p-footer>
    </p-dialog>
    <div class="row">
      <div class="col-md-6">
        <div class="col-md-12">
          <h5>Picture Card Item Component</h5>
        </div>
        <div class="mb-5">
          <label for="pictureCardTitle">Title</label>
          <input class="full-width"
                 pInputText
                 id="pictureCardTitle"
                 [(ngModel)]="locationData.pictureCard.title" />
        </div>
        <div class="mb-5">
          <label for="pictureCardButtonText">Button Text</label>
          <input class="full-width"
                 pInputText
                 id="pictureCardButtonText"
                 [(ngModel)]="locationData.pictureCard.buttonText" />
        </div>
        <div class="mb-5">
          <label for="pictureCardButtonUrl">Button Link</label>
          <input class="full-width"
                 pInputText
                 id="pictureCardButtonUrl"
                 [(ngModel)]="locationData.pictureCard.buttonUrl" />
        </div>
        <app-picture-card (onSave)="updateLocation()"
                          [(cards)]="locationData.pictureCard.cardItem"></app-picture-card>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h5>Button CTA Component</h5>
        <label for="title">Title</label>
        <input class="full-width"
               pInputText
               id="title"
               [(ngModel)]="locationData.ctaTitle" />
        <label for="text">Text</label>
        <input class="full-width"
               pInputText
               id="text"
               [(ngModel)]="locationData.ctaText" />
        <label for="image-url">Image URL</label>
        <input class="full-width"
               pInputText
               id="image-url"
               [(ngModel)]="locationData.ctaUrl" />
        <label for="left-text">Left Button Text</label>
        <input class="full-width"
               pInputText
               id="left-text"
               [(ngModel)]="locationData.leftButtonText" />
        <label for="left-link">Left Button Link</label>
        <input class="full-width"
               pInputText
               id="left-link"
               [(ngModel)]="locationData.leftButtonLink" />
        <label for="right-text">Right Button Text</label>
        <input class="full-width"
               pInputText
               id="right-text"
               [(ngModel)]="locationData.rightButtonText" />
        <label for="right-link">Right Button Link</label>
        <input class="full-width"
               pInputText
               id="righ-link"
               [(ngModel)]="locationData.rightButtonLink" />
      </div>
    </div>

    <br>
    <hr>
    <div class="row">
      <div class="col-xs-6">
        <p>
          <b>Rent a Unit Summary</b>
        </p>
        <textarea pInputTextarea
                  (change)="saveSummary('rent')"
                  class="full-width text-area-box"
                  [(ngModel)]="locationData.rentSummary"></textarea>
      </div>


      <div class="col-xs-12">
        <h5>Rent Success</h5>
        <label for="success1">Success Message</label>
        <input class="full-width"
               pInputText
               id="success-rent"
               [(ngModel)]="locationData.rentSuccessMessage" />
        <div class="sm-padding-top"></div>
        <label class="sm-padding-top"
               for="line11">Line 1</label>
        <input class="full-width"
               pInputText
               id="line11"
               [(ngModel)]="locationData.rentSuccessLine1" />
        <div class="sm-padding-top"></div>
        <label class="sm-padding-top"
               for="line21">Line 2</label>
        <input class="full-width"
               pInputText
               id="line21"
               [(ngModel)]="locationData.rentSuccessLine2" />
        <h5>Reserve Success</h5>
        <label for="success-reserve">Success Message</label>
        <input class="full-width"
               pInputText
               id="success"
               [(ngModel)]="locationData.reserveSuccessMessage" />
        <div class="sm-padding-top"></div>
        <label class="sm-padding-top"
               for="line1">Line 1</label>
        <input class="full-width"
               pInputText
               id="line1"
               [(ngModel)]="locationData.reserveSuccessLine1" />
        <div class="sm-padding-top"></div>
        <label class="sm-padding-top"
               for="line2">Line 2</label>
        <input class="full-width"
               pInputText
               id="line2"
               [(ngModel)]="locationData.reserveSuccessLine2" />
      </div>

      <div class="col-xs-6">
        <p>
          <b>Reserve a Unit Summary</b>
        </p>
        <textarea pInputTextarea
                  (change)="saveSummary('reserve')"
                  class="full-width text-area-box"
                  [(ngModel)]="locationData.reserveSummary"></textarea>
      </div>
    </div>
    <div class="row sm-padding-top">
      <div class="col-md-12">
        <h5>About Us</h5>
        <hr>
      </div>

      <ng-container [ngSwitch]="clientData?.aboutUsMainSection">
        <div *ngSwitchCase="'html'"
             class="col-xs-12">
          <p>Custom HTML</p>
          <textarea [froalaEditor]="options"
                    [(froalaModel)]="locationData?.about.whoWeAre"
                    class="full-width "></textarea>
        </div>
        <ng-container *ngSwitchCase="'rows'">
          <div *ngFor="let row of locationData?.about.rows; let i = index; let last = last; let first = first"
               [ngStyle]="{'border-bottom': last ? 'none' : '1px solid rgba(0,0,0,0.33)'}"
               class="col-xs-12 about-row">
            <div class="row">
              <div class="col-xs-12">
                <label for="about-row-title-{{i}}">Row Title</label>
                <input class="full-width"
                       pInputText
                       id="about-row-title-{{i}}"
                       [(ngModel)]="locationData?.about.rows[i].title" />
              </div>
              <div class="col-xs-12">
                <label for="about-row-image-{{i}}">Row Image URL</label>
                <input class="full-width"
                       pInputText
                       id="about-row-image-{{i}}"
                       [(ngModel)]="locationData?.about.rows[i].imageUrl" />
                <md-slide-toggle [(ngModel)]="locationData?.about.rows[i].borderRadius">
                  Border Radius
                </md-slide-toggle>
              </div>
              <div class="col-xs-12">
                <label for="about-row-image-alt-{{i}}">Row Image Alt (leave blank to use image file name)</label>
                <input class="full-width"
                       pInputText
                       id="about-row-image-alt-{{i}}"
                       [(ngModel)]="locationData?.about.rows[i].imageAltText" />
              </div>
              <div class="col-xs-12">
                <label for="about-row-layout-{{i}}">Row Layout</label>
                <p-dropdown id="about-row-layout-{{i}}"
                            [options]="aboutRowsLayoutOptions"
                            [(ngModel)]="locationData?.about.rows[i].layout"></p-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <p>HTML</p>
                <textarea [froalaEditor]="options"
                          [(froalaModel)]="locationData.about.rows[i].html"
                          class="full-width"></textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 text-center">
                <button *ngIf="!first"
                        type="button"
                        class="btn btn-secondary m-2"
                        (click)="moveAboutRow('up', i)">
                  <i class="fa fa-arrow-up"></i> Move
                </button>
                <button *ngIf="!last"
                        type="button"
                        class="btn btn-secondary m-2"
                        (click)="moveAboutRow('down', i)">
                  <i class="fa fa-arrow-down"></i> Move
                </button>
                <button type="button"
                        class="btn btn-danger m-2"
                        (click)="removeAboutRow(i)">
                  Remove Row
                </button>
              </div>
            </div>
          </div>
          <div class="col-xs-12 text-center">
            <button type="button"
                    class="btn btn-accent btn-lg m-5"
                    (click)="addAboutRow()">
              Add Row
            </button>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="col-md-6">
            <p>Who We Are</p>
            <input class="full-width"
                   placeholder="alternate title"
                   pInputText
                   (change)="updateLocation()"
                   [(ngModel)]="locationData?.about.whoWeAreHeader" />
            <textarea [froalaEditor]="options"
                      [(froalaModel)]="locationData?.about.whoWeAre"
                      class="full-width "></textarea>
          </div>
          <div class="col-md-6">
            <p>Why Us?</p>
            <input class="full-width"
                   placeholder="alternate title"
                   pInputText
                   (change)="updateLocation()"
                   [(ngModel)]="locationData?.about.whyUsHeader" />
            <textarea [froalaEditor]="options"
                      [(froalaModel)]="locationData?.about.whyUs"
                      class="full-width "></textarea>
          </div>
          <div *ngIf="clientData?.aboutUsMainSectionData?.useSlider">
            <div class="col-xs-12 my-5">
              <label>Slider URLs</label>
              <app-slideshow (onSave)="updateLocation()"
                             [slides]="locationData?.about?.aboutUsSliderUrls"
                             [showSliderArrows]="locationData.showSliderArrows"
                             [sliderAutoPlay]="locationData.sliderAutoPlay"></app-slideshow>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="row sm-padding-top">
      <div class="col-md-12">
        <h5>Contact Info</h5>
        <hr>
      </div>
      <div class="col-xs-12">
        <md-slide-toggle (change)="updateShowMailingAddress($event)"
                         [(ngModel)]="locationData.showMailingAddress">
          <p> Show mailing address on contact page</p>
        </md-slide-toggle>
        <br>
        <label for="mailingAddressBlurb">Mailing Address Blurb</label>
        <input class="full-width"
               pInputText
               id="mailingAddressBlurb"
               (change)="updateLocation()"
               [(ngModel)]="locationData.mailingAddressBlurb" />
        <label for="mailingAddress">Mailing Address</label>
        <input class="full-width"
               pInputText
               id="mailingAddress"
               (change)="updateLocation()"
               [(ngModel)]="locationData.mailingAddress" />
        <label for="mailingAddress2">Mailing Address 2</label>
        <input class="full-width"
               pInputText
               id="mailingAddress2"
               (change)="updateLocation()"
               [(ngModel)]="locationData.mailingAddress2" />
      </div>
    </div>
    <div class="row sm-padding-top">
      <div class="col-md-12">
        <h5>Insurance Info</h5>
        <hr>
      </div>
      <div class="col-xs-12">
        <label for="reservationBlurb">Location Insurance Blurb</label>
        <textarea pInputTextarea
                  id="insuranceBlurb"
                  class="full-width"
                  [froalaEditor]="options"
                  [(froalaModel)]="locationData.customBlurbInsurance"></textarea>
      </div>
    </div>
    <div class="row sm-padding-top">
      <div class="col-xs-12">
        <button style="float: right;"
                (click)="updateLocation()"
                class="btn btn-secondary"
                color="accent">Save</button>
      </div>
    </div>
  </md-card>
</div>

<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/location-component-data-settings/location-component-data-settings.component.html